import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormService } from 'src/app/services/form.service';
import { ModalService } from 'src/app/services/modal.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-emitirvotopreguntamodal',
  templateUrl: './emitirvotopreguntamodal.component.html',
  styleUrls: ['./emitirvotopreguntamodal.component.css']
})
export class EmitirvotopreguntamodalComponent implements OnInit {

  @Input() data;
  form: FormGroup;
  submitted: Boolean = false;

  constructor(private activeModal: NgbActiveModal, private formService: FormService, private modal: ModalService,
    private alert: NotificacionesService, private utils: UtilsService) {
  }

  ngOnInit(): void {
    this.form = this.formService.getEmitirVotoPreguntaModalForm(this.data);
  }

  accept() {
    this.submitted = true;
    if (this.form.invalid)
      return;
    this.modal.mostrarModalCargando();
    if (this.form.value.id > 0)
      this.update(this.form.value);
    else
      this.save(this.form.value);
  }

  save(llaves) {
    this.modal.cerrarModalCargando();
    // this.personService.save(llaves).subscribe((data: any) => {
    // if (data.responseCode === AppConstants.RESPONSECODES.OK)
    //   this.alert.success(data.message, true);
    // else
    //   this.alert.error(data.message, true);
    // this.modal.cerrarModalCargando();
    this.close();
    // }, (error: any) => {
    //   console.error('Error', error);
    //   this.modal.cerrarModalCargando();
    // });
  }

  update(llaves) {
    this.modal.cerrarModalCargando();
    // this.personService.update(llaves).subscribe((data: any) => {
    //   if (data.responseCode === AppConstants.RESPONSECODES.OK)
    //     this.alert.success(data.message, true);
    //   else
    //     this.alert.error(data.message, true);
    //   this.modal.cerrarModalCargando();
    this.close();
    // }, (error: any) => {
    //   console.error('Error', error);
    //   this.modal.cerrarModalCargando();
    // });
  }

  dismiss() {
    this.activeModal.dismiss();
  }

  close() {
    this.activeModal.close();
  }

}
